import { render, staticRenderFns } from "./copertevkifatkodu.vue?vue&type=template&id=1d63426e&"
import script from "./copertevkifatkodu.vue?vue&type=script&lang=js&"
export * from "./copertevkifatkodu.vue?vue&type=script&lang=js&"
import style0 from "./copertevkifatkodu.vue?vue&type=style&index=0&id=1d63426e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports